import { render, staticRenderFns } from "./ArchivoSolicitud.vue?vue&type=template&id=12a09e6a&"
import script from "./ArchivoSolicitud.vue?vue&type=script&lang=js&"
export * from "./ArchivoSolicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports